<template>
  <el-dialog
    :visible.sync="modifyDialogVisible"
    width="700px"
    top="5vh"
    custom-class="modify-avatar"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false">
    <template slot="title">
      头像设置 <small>为了更好的展示您的形象，请让头像与参考形状对齐</small>
    </template>
    <div class="content">
      <div class="cut-area">
        <div class="cut-init">
          <vueCropper
            ref="cropper"
            :img="srcClone"
            :autoCrop="true"
            :autoCropWidth="200"
            :autoCropHeight="200"
            :fixed="true"
            :fixedNumber="[1, 1]"
            @realTime="realTime"
          ></vueCropper>
        </div>
        <p class="operation clearfix">
          <el-button type="text" class="pull-left" icon="iconfont icon--img">
            重新上传
          </el-button>
          <input type="file" accept="image/png, image/jpeg, image/jpg" @change="uploadImg">
          <el-button type="text" class="pull-right" icon="iconfont icon--rotate" @click="rotateRight"></el-button>
        </p>
      </div>
      <div class="preview-area">
        <ul class="list">
          <li class="item">
            <p class="title">圆形预览</p>
            <div class="img-wrap round">
              <img :src="url">
            </div>
          </li>
          <li class="item">
            <p class="title">方形预览</p>
            <div class="img-wrap square">
              <img :src="url">
            </div>
          </li>
          <li class="item">
            <p class="title">矩形预览</p>
            <div class="img-wrap rectangle">
              <img :src="url">
            </div>
          </li>
        </ul>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import VueCropper from 'vue-cropper'
import ImageUtil from '@/utils/image.js'
import Validate from '@/utils/validate.js'

export default {
  props: {
    modifyDialogVisible: Boolean,
    src: String
  },
  data () {
    return {
      url: null,
      srcData: this.src,
      imageInfo: null
    }
  },
  computed: {
    srcClone () {
      let src = this.srcData
      if (Validate.isValid('link', src)) {
        src += `?d${new Date().getTime()}`
      }
      return src
    }
  },
  methods: {
    handleClose () {
      this.cancel()
    },
    realTime (data) {
      this.imageInfo = data
      this.$refs.cropper.getCropData((data) => {
        this.url = data
      })
    },
    rotateRight () {
      this.$refs.cropper.rotateRight()
    },
    uploadImg (e) {
      var file = e.target.files[0]
      if (!/\.(jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        this.$message.error('图片类型必须是.jpeg,jpg,png,bmp中的一种')
        return false
      }
      var reader = new FileReader()
      reader.onload = (e) => {
        let data
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        this.srcData = data
      }
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file)
    },
    cancel () {
      this.srcData = this.src
      this.$emit('closeModifyDialog')
    },
    save () {
      // 获取截图的blob数据
      this.$refs.cropper.getCropBlob((blob) => {
        let url = ImageUtil.getObjectURL(blob)
        let name = ImageUtil.getCDNName(url, this.imageInfo.w, this.imageInfo.h, blob.size, blob.type)
        let imgname = `acagrid/usercontent/avatar/${name}`
        let imgurl = `https://img.okay.do/acagrid/usercontent/avatar/${name}`
        ImageUtil.uploadImg(blob, imgname, () => {
          this.srcData = imgurl
          this.$emit('avatarOperation', this.srcData)
          this.$emit('closeModifyDialog')
        })
      })
    },
    handleUpload () {
      console.log('click')
      document.querySelector('#input-uploadImg').click()
    }
  },
  components: {
    VueCropper,
    ImageUtil,
    Validate
  }
}
</script>
<style lang="scss">
  @import './index.scss';
</style>



// WEBPACK FOOTER //
// src/pages/Index/ModifyAvatar/index.vue